
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NProgress from "nprogress";
import {Dialog, Toast} from "vant";
import CommonFunction from "@/utils/CommonFunction";

export const PAGE_GROUP = {
  BASIC:{code:'basic', name: '基础'},
  WORK:{code:'word', name: '工作'},
  RECREATION:{code:'recreation', name: '娱乐'},
  MODULE:{code:'module', name: '组件'},
  UTIL:{code:'util', name: '工具'},
  OTHER:{code:'other', name: '其他'},
}


Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'home',
    component: HomeView,
    meta:{
      name: '旅途向导者',
      icon: 'icon-home',
      group: PAGE_GROUP.BASIC
    }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import("@/views/tools/WebSiteStatistics.vue"),
    meta:{
      name: '网站统计',
      icon: 'icon-home',
      group: PAGE_GROUP.BASIC
    }
  },
  {
    path: '/create-order',
    name: 'CreateOrder',
    component: () => import("@/views/work/CreateOrder.vue"),
    meta: {
      name: '创建订单',
      icon: 'icon-list',
      group: PAGE_GROUP.WORK,


    }
  },
  {
    path: '/guide-svg',
    name: 'GuideSvg',
    component: () => import("@/views/work/GuideBookSvg.vue"),
    meta: {
      name: '老君山导览图',
      icon: 'icon-map',
      group: PAGE_GROUP.WORK,


    }
  },
  {
    path: '/push-data',
    name: 'PushData',
    component: () => import("@/views/work/PushData.vue"),
    meta: {
      name: '信息提交',
      icon: 'icon-commit',
      group: PAGE_GROUP.WORK,
    }
  },
  {
    path: '/bill',
    name: 'Bills',
    component: () => import("@/views/work/Bills.vue"),
    meta: {
      name: '报账单',
      icon: 'icon-zhangdan',
      group: PAGE_GROUP.WORK,

    }
  },
  {
    path: '/clock',
    name: 'Clock',
    component: () => import("@/views/ClockView.vue"),
    meta: {
      name: '时钟',
      icon: 'icon-clock',
      group: PAGE_GROUP.RECREATION,

    }
  },
  {
    path: '/device-info',
    name: 'DeviceInfo',
    component: () => import("@/views/DeviceInfo.vue"),
    meta: {
      name: '设备信息',
      icon: 'icon-device',
      group: PAGE_GROUP.MODULE,
    }
  },
  {
    path: '/development-logs',
    name: 'DevelopmentLogs',
    component: () => import("@/views/DevelopmentLog.vue"),
    meta: {
      name: '开发日志',
      icon: 'icon-dev-log',
      group: PAGE_GROUP.BASIC,
    }
  },
  {
    path: '/link-share',
    name: 'LinkShare',
    component: () => import("@/views/LinkShare.vue"),
    meta: {
      name: '技术分享',
      icon: 'icon-share-s',
      group: PAGE_GROUP.OTHER,
    }
  },
  {
    path: '/colors',
    name: 'Colors',
    component: () => import("@/views/ColorView.vue"),
    meta: {
      name: '色彩',
      icon: 'icon-colors-theme',
      group:PAGE_GROUP.MODULE
    }
  },
  {
    path: '/sys-convert',
    name: 'SysConvert',
    component: () => import("@/views/tools/SysConvert.vue"),
    meta: {
      name: '色彩透明度转换',
      icon: 'icon-alpha',
      group:PAGE_GROUP.MODULE
    }
  },
  {
    path: '/css-filter',
    name: 'CSSFilter',
    component: () => import("@/views/tools/CSSFilter.vue"),
    meta: {
      name: 'CSS filter效果',
      icon: 'icon-magic',
      group:PAGE_GROUP.MODULE
    }
  },
  {
    path: '/evan-calendar',
    name: 'Calendar',
    component: () => import("@/views/tools/CalendarPage.vue"),
    meta: {
      name: '日历组件',
      icon: 'icon-calendar',
      group:PAGE_GROUP.MODULE
    }
  },
  {
    path: '/md-edit',
    name: 'MarkdownEdit',
    component: () => import("@/views/markdown/CherryEditMD.vue"),
    meta: {
      name: '编辑器',
      icon: 'icon-md',
      tag: 'PC',
      footer:false,
      onlyPc: false,
      group: PAGE_GROUP.MODULE
    },

  },
  {
    path: '/md-preview',
    name: 'MarkdownPewview',
    component: () => import("@/views/markdown/CherryPreviewMD.vue"),
    meta: {
      name: '文章预览',
      icon: 'icon-read',
      tag: 'test',
      group: PAGE_GROUP.MODULE
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/views/AboutView.vue"),
    meta:{
      name: '关于本站',
      icon: 'icon-about',
      group: PAGE_GROUP.BASIC
    }
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/views/agreement/UserAgreement.vue"),
    meta:{
      name: '用户协议',
      icon: 'icon-agreement',
      group: PAGE_GROUP.BASIC
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


let loadToast = null;
router.beforeEach((to,from,next) =>{
  NProgress.start();

  console.log('from',from,'to', to);
  // if (/\/(http|https):\/\//.test(to.path)) {
  //   /*let link = to.path.replace(/^.*?(https?:\/\/)/, '')*/
  //   next({ path: '/linkWeb', query: { target: to.path.replace(/^.*?(https?:\/\/)/, '') } });
  //
  // }else{
  //   console.log(from);
  //   to.meta.preRoute = from;
  //   next();
  // }
  if (to.meta.hasOwnProperty('onlyPc') && to.meta.onlyPc&&CommonFunction.detectDeviceIsMobileUA()) {

    Dialog({title:'页面跳转提示',theme:'round-button',message: '为了保持良好的视觉效果，该页面仅支持PC端访问'}).then(r =>{
          next(false);
    })
        return;
  }

  if (to.meta.hasOwnProperty('onlyMobile') && to.meta.onlyMobile && !CommonFunction.detectDeviceIsMobileUA()) {
    Dialog({title:'页面跳转提示',theme:'round-button',message: '为了保持良好的视觉效果，该页面仅支持移动端访问'}).then(r =>{
      next(false);
    })
    return;
  }
  loadToast = Toast.loading({loadingType:"spinner",message:`跳转到${to.meta.name||'新页面'}`,duration:0,mask:true})
  to.meta.preRoute = from;
  next();
})

router.afterEach((to,from) =>{
  document.title =
      (to.meta.name  ? to.meta.name+' - 旅途向导者' :' 旅途向导者');
console.log(from)
  /*  var link = document.querySelector("link[rel='icon']")
    link.href = to.meta.icon || '/favicon.ico'*/
  NProgress.done();
  loadToast.clear();
})
const IgnoreErrorName = ['NavigationCancelled','NavigationDuplicated'];
router.onError(error => {
  console.log(error);
  if (IgnoreErrorName.includes(error.name)) {
    return; // 忽略取消的导航
  }
  // 处理其他错误
});





// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router
